module.exports = __webpack_public_path__ + "static/media/8.12ce93f7.png";